// extracted by mini-css-extract-plugin
module.exports = {"root":"rT","countbox":"rU","expireDate":"rV"};